import { tinycolor } from "@thebespokepixel/es-tinycolor";
import initPictureZoom from "./PictureZoom";

import MediaQueries from "../utils/MediaQueries";
import BrowserDetect from "../utils/BrowserDetect";
import ShareButtons from "../social/ShareButtons";
import Notification from "../notification/Notification";
import I18n from "../i18n/Translation";
import * as DomUtils from "../utils/DomUtils";

$(function () {

    // Global variables
    let lastScrollTop = 0,
        scrollTopAmount = 0,
        scrollDownAmount = 0,
        isInviteToScrollVisible = true,
        st = $(this).scrollTop(),
        isScrollingUp = st < lastScrollTop,
        nav = MediaQueries.isLgUp() ? $(".desktop-nav") : $(".mobile-top-bar"),
        navHeight = nav.length > 0 ? nav.height() : 0,
        screenHeight = window.innerHeight - navHeight,
        screenWidth = window.innerWidth,
        // CSS
        $mainContainer = $(".main-container"),
        desktopChapterBarClass = "chapter-bar-desktop",
        chapterBarListItemClass = "chapter-bar__open-list__item",
        chapterBarListClass = "chapter-bar__chapters__container__list",
        chapterBarTitleClass = "chapter-bar__chapters__container__list__item",
        preloaderClass = "storytelling-preloader",
        preloaderLoadingProgressClass = "storytelling-preloader__loading-progress",
        $desktopChapterBar = $("." + desktopChapterBarClass),
        chaptersLength = $desktopChapterBar.attr("data-chapters-length") || 0,
        $firstChapter = $("#chapter-1"),
        $preloader = $("." + preloaderClass),
        $preloaderLoadingProgress = $("." + preloaderLoadingProgressClass),
        $paperEffectItems = $(".article-resume__container--overlap, #storytelling-intro, .table-of-content, .dc-ad-container--leaderboard"),
        preventAnimations = st > 0, // prevent all animations if user has scrolled and refreshed the page
        mainColor = DomUtils.getMetadata("mainColor"), // use this color instead of edition color if defined
        backgroundColor = DomUtils.getMetadata("backgroundColor");

    // Global variables (mobile)
    let mobileChapterBarClass = "chapter-bar-mobile",
        $mobileChapterBar = $("." + mobileChapterBarClass),
        $mobileCurrentChapterNumber = $(".chapter-bar__current-chapter-number"),
        burgerMenuClass = "burger-menu",
        $burgerMenu = $("." + burgerMenuClass);

    // Apply default theme for IE
    if(BrowserDetect.isIe11orBelow()) {
        let $body = $("body");
        $body.removeClass("theme-paper theme-dark");
        $body.addClass("theme-default");
    // Apply custom color
    } else if(mainColor) {
        let hslMainColor = tinycolor(mainColor).toHsl(),
            $articleContent = $(".article-page-content"),
            $shareButton = $(".share__button");

        $articleContent.css("--primary", mainColor);
        $articleContent.css("--primary-h", Math.round(hslMainColor.h) + "deg");
        $articleContent.css("--primary-s", Math.round(hslMainColor.s * 100) + "%");
        $articleContent.css("--primary-l", Math.round(hslMainColor.l * 100) + "%");
        // Exception for share button on mobile
        $shareButton.css("background-color", mainColor);

        // Apply a special background color based on main color (dark theme only)
        if(backgroundColor) {
            $mainContainer.css("--main-bg-color", backgroundColor);
        }
    }

    // Re-apply Medium.com zoom effect on pictures because background color can be different than normal article background
    let zoomBackgroundColor = getComputedStyle($mainContainer[0]).getPropertyValue("--main-bg-color");
    initPictureZoom(zoomBackgroundColor);

    //ios fix
    if(window.location.href.indexOf("isIos") !== -1) {
        $('html').addClass("internal-storytelling--ios");
    }

    let _extractChapterNumber = function(chapterString = "") {
        let chapterMatch = chapterString.match(/^.*-([0-9])$/);
        return chapterMatch && chapterMatch[1] ? chapterMatch[1] : null;
    };

    let _setCurrentChapter = (id = "") => {
        let chapterId = id === "" || id < 1 ? 1 : id, // Select chapter 1 if no valid chapter is provided
            $currentChapterTitle = $(`.${chapterBarTitleClass}--active`),
            $chapterBarList = $(`.${chapterBarListClass}`),
            $currentChapterBarListItem = $(`.${chapterBarListItemClass}--active`),
            $newChapterTitle = $(".chapter-list-item-" + chapterId);

        if(_extractChapterNumber($currentChapterTitle.attr("id")) === chapterId)
            return;

        // Show current chapter title
        $chapterBarList.each(function() {
            $(this).attr("class", `${chapterBarListClass} ${chapterBarListClass}--${chapterId}`);
        });

        // Select current chapter in the bar list
        $currentChapterBarListItem.each(function() {
            $(this).removeClass(`${chapterBarListItemClass}--active`);
        });
        $newChapterTitle.each(function() {
            $(this).addClass(`${chapterBarListItemClass}--active`);
        });

        // Show current chapter number for mobile
        $mobileCurrentChapterNumber.html(`0${chapterId} / 0${chaptersLength}`);
    };

    let _hideChapterBar = function() {
        $desktopChapterBar.removeClass(`${desktopChapterBarClass}--visible ${desktopChapterBarClass}--open`);
        $mobileChapterBar.removeClass(`${mobileChapterBarClass}--visible ${mobileChapterBarClass}--open`);
        $burgerMenu.removeClass(burgerMenuClass + "--active");
    };

    let _showChapterBar = function() {
        $desktopChapterBar.addClass(`${desktopChapterBarClass}--visible`);
        $mobileChapterBar.addClass(`${mobileChapterBarClass}--visible`);
    };

    let _easeInCubic = (t) => t*t*t;



    /**
     * Chapters anchor links copy
     */
    let initChapterAnchorCopy = function () {
        ShareButtons.init("chapter__container__title__anchor");
        $(".chapter__container__title__anchor").click(function () {
            var self = this;
            $(this).addClass("chapter__container__title__anchor--visible");
            Notification.show(I18n.translate("share-buttons.copy-to-clipboard-message"));

            window.setTimeout(function () {
                $(self).removeClass("chapter__container__title__anchor--visible");
            }, 250);
        });
    }


    /**
     * Chapter bar
     */
    let initChapterBar = function () {

        let $chapterBarItem = $("." + chapterBarListItemClass),
            $chapterBarChapters = $(".chapter-bar__chapters"),
            currentChapterId = _extractChapterNumber(window.location.hash.substr(1));

        $chapterBarChapters.click(function () {
            // Show/hide the menu
            $desktopChapterBar.toggleClass(desktopChapterBarClass + "--open");
        });
        $burgerMenu.click(function () {
            // Show/hide the menu
            $mobileChapterBar.toggleClass(mobileChapterBarClass + "--open")
        });

        $chapterBarItem.each(function() {
            $(this).click(function () {
                setTimeout(_hideChapterBar, 100); // Prevent scroll event to show the bar if user select a previous chapter thant the current one
                // Select clicked chapter in the bar list
                $("." + chapterBarListItemClass + "--active").removeClass(chapterBarListItemClass + "--active");
                $(this).addClass(chapterBarListItemClass + "--active")
            });
        });

        _setCurrentChapter(currentChapterId);

        watchChapters();
    };

    let watchChapters = function () {
        // Watch if a chapter is visible in the viewport
        // If so, update the chapter bar according to this chapter
        let chapterObserver = new IntersectionObserver(entries => {
            let appearingChapter = entries.find(e => e.isIntersecting);
            let disappearingChapter = entries.find(e => !e.isIntersecting);

            if(appearingChapter) {
                let chapterId = _extractChapterNumber(appearingChapter.target.getAttribute("id"));
                _setCurrentChapter(chapterId);
            } else if(disappearingChapter) {
                let chapterId = _extractChapterNumber(disappearingChapter.target.getAttribute("id"));
                let newChapterId = isScrollingUp ? chapterId - 1 : chapterId;
                _setCurrentChapter(newChapterId);
            }
        }, {
            rootMargin: '0px',
            threshold: 0
        });

        for(let chapterId = 1; chapterId < chaptersLength + 1; chapterId++) {
            let chapter = document.querySelector(`#chapter-${chapterId}`);
            if(chapter) {
                chapterObserver.observe(chapter);
            }
        }
    };

    /**
     * Main picture
     */
    let initMainPicture = function () {
        let $intro = $(".intro"),
            resizeTimer,
            mobileBottomBar = document.querySelector(".mobile-bottom-bar");

        // Main picture will take the full screen height
        $intro.css("height", window.innerHeight - (mobileBottomBar ? mobileBottomBar.offsetHeight : 0));
        $intro.addClass("visible");

        // Preloader wort logo animation
        // We show a fake loading progress in the logo, starting from 100% to 20%
        // Then we wait, until the onload event, we update the loading progress to 100% and we hide the logo
        // We have a fallback to 10s in case of something wrong happened
        let loadingProgress = (loadingValue = 100) => setTimeout(() => {
            $preloaderLoadingProgress.css({
                "transform": "translate3d(0, " + loadingValue + "%, 0)"
            });
            loadingValue -= Math.floor(Math.random() * 20);
            if(loadingValue >= 20) {
                loadingProgress(loadingValue);
            }
        }, Math.round(100 + Math.random() * 150));

        loadingProgress();

        window.onload = function () {
            // When page is fully loaded, hide the preloader and show the main picture
            $preloaderLoadingProgress.addClass(preloaderLoadingProgressClass + "--filled");
            setTimeout(function() {
                $preloader.addClass(preloaderClass + "--hidden");
            }, 500);
        };

        window.addEventListener("resize", function () {
            clearTimeout(resizeTimer);


            resizeTimer = setTimeout(function() {
                let currentScreenWidth = window.innerWidth;
                // On mobile, the native browser topbar will disappear on scroll and trigger a resize event
                // In this case, we don't want to update the main picture size
                // On other case, just adapt the picture size to make it responsive
                if(screenWidth !== currentScreenWidth) {
                    $intro.css("height", window.innerHeight - (mobileBottomBar ? mobileBottomBar.offsetHeight : 0));
                }
                screenWidth = currentScreenWidth;
            }, 250);
        });

        // Fallback in case of something wrong
        setTimeout(function() {
            $preloader.addClass(preloaderClass + "--hidden");
        }, 10000);
    };

    /**
     * Burger menu
     */
    let initChapterBarBurgerMenu = function () {
        $burgerMenu.click(function () {
            $burgerMenu.toggleClass(burgerMenuClass + "--active")
        });
    };

    /**
     * Scroll
     */
    let initScroll = function() {
        window.addEventListener('scroll', _onScroll, false);
    };

    let _onScroll = function() {
        requestAnimationFrame(function () {
            st = window.scrollY || document.documentElement.scrollTop; // Modern browser / IE
            // Ignore when trackpad give sometimes back the same scroll value than before
            if(st === lastScrollTop)
                return;

            isScrollingUp = st < lastScrollTop;
            if(isScrollingUp) {
                if(st === 0) {
                    preventAnimations = false
                }
                scrollDownAmount = 0;
                scrollTopAmount += lastScrollTop - st;
            } else {
                scrollTopAmount = 0;
                scrollDownAmount += st - lastScrollTop;
            }
            handleScroll();
            lastScrollTop = st;
        });
    };

    let handleScroll = function () {
        // Invite to scroll
        if (st > 50 && isInviteToScrollVisible) {
            isInviteToScrollVisible = !isInviteToScrollVisible;
            $(".invite-to-scroll-wrapper").addClass("hidden");
        }

        if (st < 400) {
            if(preventAnimations)
                return;

            // Background animation
            let scale =  (1 + (st / 7500)).toFixed(5);
            if(scale > 1.2) scale = 1.2;

            if(!BrowserDetect.isAndroid()) {
                $(".intro__background__image").css({
                    "transform": "translate3d(0," + (st / 2).toFixed(0) + "px, 0) scale(" + scale + ")"
                });
            }

            // Paper overlap animation
            let transformValue = (_easeInCubic(st / 50) / 4).toFixed(0);

            $paperEffectItems.css({
                "transform": "translate3d(0,-" + transformValue + "px, 0)"
            });

            $(".article-resume__shadow").css({
                "box-shadow": "0 -5px 5px rgba(0,0,0," + (transformValue / 100) / 3 + ")"
            });

            // Title parallax animation
            transformValue = (_easeInCubic(st / 50)).toFixed(0);
            let titleOpacity = ((screenHeight - (st - 125) * 4) / screenHeight).toFixed(2);

            $(".intro__center").css({
                "transform": "translate3d(0," + transformValue / 2 + "px, 0)",
                "opacity": titleOpacity
            });

        } else {
            // Force paper scroll effect in case of fast scroll
            $paperEffectItems.css({
                "transform": "translate3d(0,-128px, 0)"
            });
        }

        if($firstChapter.length > 0) {
            // Always close chapter bar menu during scroll
            $desktopChapterBar.removeClass(desktopChapterBarClass + "--open");
            $mobileChapterBar.removeClass(mobileChapterBarClass+ "--open");

            if (isScrollingUp && scrollTopAmount >= 30) {
                // Show the bar (smoothly) after a short amount of scroll up and only if we're under the first chapter
                if(st > $firstChapter.offset().top - 200) {
                    _showChapterBar();
                } else {
                    _hideChapterBar();
                }
            // Hide the bar (smoothly) after a short amount of scroll down
            } else if(scrollDownAmount >= 50) {
                _hideChapterBar();
            }
        }
    };

    // Initialize chapter bar only if there are some chapters in the article
    initMainPicture();
    initScroll();

    if($firstChapter.length > 0) {
        initChapterBar();
        initChapterBarBurgerMenu();
        initChapterAnchorCopy();
    }
});



// WEBPACK FOOTER //
// ./js/page/StorytellingPage.js